import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/img/oto-academy/banner-principal.png';
import _imports_1 from '@/assets/img/oto-academy/icon-1.svg';
import _imports_2 from '@/assets/img/oto-academy/icon-2.svg';
import _imports_3 from '@/assets/img/oto-academy/icon-3.svg';
import _imports_4 from '@/assets/img/oto-academy/banner-2-conteudos.png';
import _imports_5 from '@/assets/img/oto-academy/banner-3-trilha.png';
import _imports_6 from '@/assets/img/oto-academy/stars.svg';
import _imports_7 from '@/assets/img/oto-academy/banner-final.png';
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("h1", { class: "oto-academy__header__title" }, [
    /*#__PURE__*/ _createElementVNode("b", null, "Oto Academy"),
    /*#__PURE__*/ _createTextVNode(", a plataforma de learning exclusiva do Oto")
], -1);
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("p", { class: "oto-academy__header__description" }, [
    /*#__PURE__*/ _createTextVNode(" Desenvolvemos uma plataforma de conteúdo para que a sua marca possa "),
    /*#__PURE__*/ _createElementVNode("b", null, "aproveitar todo o potencial do Oto"),
    /*#__PURE__*/ _createTextVNode(" e "),
    /*#__PURE__*/ _createElementVNode("b", null, "conquistar resultados cada vez mais expressivos.")
], -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_0,
    class: "oto-academy__header__banner"
}, null, -1);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("section", { class: "oto-academy__list" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "oto-academy__list__item--1" }, [
        /*#__PURE__*/ _createElementVNode("div", null, [
            /*#__PURE__*/ _createElementVNode("img", { src: _imports_1 })
        ]),
        /*#__PURE__*/ _createElementVNode("p", null, "Conteúdos e treinamentos de fácil acesso, disponíveis a qualquer momento.")
    ]),
    /*#__PURE__*/ _createElementVNode("div", { class: "oto-academy__list__item--2" }, [
        /*#__PURE__*/ _createElementVNode("div", null, [
            /*#__PURE__*/ _createElementVNode("img", { src: _imports_2 })
        ]),
        /*#__PURE__*/ _createElementVNode("p", null, "Plataforma desenvolvida para sua marca alcançar novos patamares de sucesso.")
    ]),
    /*#__PURE__*/ _createElementVNode("div", { class: "oto-academy__list__item--3" }, [
        /*#__PURE__*/ _createElementVNode("div", null, [
            /*#__PURE__*/ _createElementVNode("img", { src: _imports_3 })
        ]),
        /*#__PURE__*/ _createElementVNode("p", null, "Para Times de CRM e Marketing, Gerentes e Supervisores de Loja, Embaixadores e Usuários do Oto Web.")
    ])
], -1);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("h2", null, "Conteúdos selecionados para você", -1);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("ul", { class: "oto-academy__contents__list" }, [
    /*#__PURE__*/ _createElementVNode("li", null, [
        /*#__PURE__*/ _createElementVNode("span", null, "Dominar conceitos importantes sobre CRM")
    ]),
    /*#__PURE__*/ _createElementVNode("li", null, [
        /*#__PURE__*/ _createElementVNode("span", null, "Criar campanhas, audiências e templates de mensagem")
    ]),
    /*#__PURE__*/ _createElementVNode("li", null, [
        /*#__PURE__*/ _createElementVNode("span", null, "Engajar vendedores com nossos materiais exclusivos")
    ]),
    /*#__PURE__*/ _createElementVNode("li", null, [
        /*#__PURE__*/ _createElementVNode("span", null, "Potencializar a sua análise de indicadores e muito mais!")
    ])
], -1);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("img", { src: _imports_4 }, null, -1);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("img", { src: _imports_5 }, null, -1);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("h2", null, "Para cada momento, uma trilha especial", -1);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("ul", { class: "oto-academy__trilha__list" }, [
    /*#__PURE__*/ _createElementVNode("li", null, [
        /*#__PURE__*/ _createElementVNode("span", null, "Treinamentos iniciais para o uso do Oto CRM")
    ]),
    /*#__PURE__*/ _createElementVNode("li", null, [
        /*#__PURE__*/ _createElementVNode("span", null, "Conteúdos para você se aprofundar sobre a tecnologia")
    ]),
    /*#__PURE__*/ _createElementVNode("li", null, [
        /*#__PURE__*/ _createElementVNode("span", null, "Webinars com grandes marcas do varejo")
    ]),
    /*#__PURE__*/ _createElementVNode("li", null, [
        /*#__PURE__*/ _createElementVNode("span", null, "Relembre funcionalidades com o Oto Ajuda")
    ])
], -1);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("section", { class: "oto-academy__testimony" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "oto-academy__testimony__container" }, [
        /*#__PURE__*/ _createElementVNode("div", { class: "oto-academy__testimony__item" }, [
            /*#__PURE__*/ _createElementVNode("img", { src: _imports_6 }),
            /*#__PURE__*/ _createElementVNode("h4", null, "Muito bom e esclarecedor, parabéns!"),
            /*#__PURE__*/ _createElementVNode("strong", null, "— Monique Santos"),
            /*#__PURE__*/ _createElementVNode("span", null, "Postou em Entenda o cálculo de Loja e Vendedor de Preferência")
        ]),
        /*#__PURE__*/ _createElementVNode("div", { class: "oto-academy__testimony__item" }, [
            /*#__PURE__*/ _createElementVNode("img", { src: _imports_6 }),
            /*#__PURE__*/ _createElementVNode("h4", null, "Ótima iniciativa"),
            /*#__PURE__*/ _createElementVNode("strong", null, "— Paulo Cristovão"),
            /*#__PURE__*/ _createElementVNode("span", null, "Postou em Como funciona o Oto Academy?")
        ])
    ])
], -1);
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("h3", null, "Tudo pronto para alcançar resultados incríveis com o Oto CRM?", -1);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("span", null, "Acelere o seu crescimento e aumente as vendas da loja com a nossa plataforma de learning exclusiva.", -1);
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("img", { src: _imports_7 }, null, -1);
import { reactive, computed, onMounted } from 'vue';
import store from '@/store';
import ModalCreateUser from '@/features/LandingPage/components/ModalCreateUser.vue';
import ModalCreatedUser from '@/features/LandingPage/components/ModalCreatedUser.vue';
import { useMixpanelOtoAcademy, useMixpanelOpenModal } from '@/utilities/mixpanel/landingPageOtoAcademy';
import { useToast } from 'vue-toastification';
import { getUser, createUser } from '@/services/otoAcademy';
export default /*#__PURE__*/ _defineComponent({
    __name: 'LandingPageOtoAcademy',
    setup(__props) {
        const modal = reactive({
            createUser: {
                loading: false,
                visible: false,
            },
            createdUser: {
                visible: false,
            },
        });
        const toast = useToast();
        const getEmail = computed(() => {
            return store.getters.user?.email;
        });
        const getName = computed(() => {
            return store.getters.user?.name;
        });
        const getBrand = computed(() => {
            return store.getters.selectedBrand?.brand;
        });
        const onCreateUser = async ($event) => {
            const verifyUser = await verifyIfUserExists($event.target.innerText);
            if (verifyUser || verifyUser === null)
                return;
            modal.createUser.loading = true;
            modal.createUser.visible = true;
            await createUser(getEmail.value, `${getName.value} - ${getBrand.value}`)
                .then(() => {
                modal.createUser.loading = false;
            })
                .catch(() => {
                toast.error('Um erro inesperado aconteceu. Tente se registrar mais tarde, ou fale com o suporte para que consiga um convite de acesso.', {
                    timeout: 15000,
                });
            });
        };
        const verifyIfUserExists = async (nameButton) => {
            return await getUser(getEmail.value)
                .then(response => {
                if (response?.data?.data.length) {
                    modal.createdUser.visible = true;
                    useMixpanelOpenModal('view_oto-academy_open-modal', true, nameButton);
                    return true;
                }
                useMixpanelOpenModal('view_oto-academy_open-modal', false, nameButton);
                return false;
            })
                .catch(() => {
                toast.error('Um erro inesperado aconteceu. Tente se registrar mais tarde, ou fale com o suporte para que consiga um convite de acesso.', {
                    timeout: 15000,
                });
            });
        };
        const hide = typeModal => {
            modal[typeModal].visible = false;
        };
        onMounted(() => {
            useMixpanelOtoAcademy('view_oto-academy');
        });
        return (_ctx, _cache) => {
            const _component_base_card_v2 = _resolveComponent("base-card-v2");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_component_base_card_v2, { class: "oto-academy" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", { class: "oto-academy__header" }, [
                            _hoisted_1,
                            _hoisted_2,
                            _createElementVNode("button", {
                                class: "oto-academy__btn",
                                onClick: onCreateUser,
                                "data-cy": "oto-academy-btn"
                            }, "Acesse agora"),
                            _hoisted_3
                        ]),
                        _hoisted_4,
                        _createElementVNode("section", { class: "oto-academy__contents" }, [
                            _createElementVNode("div", { class: "oto-academy__contents__container" }, [
                                _hoisted_5,
                                _hoisted_6,
                                _createElementVNode("button", {
                                    class: "oto-academy__link",
                                    onClick: onCreateUser
                                }, "Quero explorar o Oto Academy")
                            ]),
                            _hoisted_7
                        ]),
                        _createElementVNode("section", { class: "oto-academy__trilha" }, [
                            _hoisted_8,
                            _createElementVNode("div", { class: "oto-academy__trilha__container" }, [
                                _hoisted_9,
                                _hoisted_10,
                                _createElementVNode("button", {
                                    class: "oto-academy__link",
                                    onClick: onCreateUser
                                }, "Quero explorar o Oto Academy")
                            ])
                        ]),
                        _hoisted_11,
                        _createElementVNode("section", { class: "oto-academy__footer" }, [
                            _createElementVNode("div", { class: "oto-academy__footer__info" }, [
                                _hoisted_12,
                                _hoisted_13,
                                _createElementVNode("button", {
                                    class: "oto-academy__btn",
                                    onClick: onCreateUser
                                }, "Quero vender mais com o Oto")
                            ]),
                            _hoisted_14
                        ])
                    ]),
                    _: 1
                }),
                _createVNode(ModalCreateUser, {
                    onHide: hide,
                    isVisible: modal.createUser.visible,
                    email: getEmail.value,
                    loading: modal.createUser.loading
                }, null, 8, ["isVisible", "email", "loading"]),
                _createVNode(ModalCreatedUser, {
                    onHide: hide,
                    isVisible: modal.createdUser.visible,
                    email: getEmail.value
                }, null, 8, ["isVisible", "email"])
            ], 64));
        };
    }
});
